import http from '@plugin/axios'

function getlist(list: any[] = []) {
  return Object.freeze(list)
}

export default async function getData(params: any) {
  params.field = 'docDate'
  params.order = 'asc'
  const info = await http<any>({
    url: '/srmPurWorkorder/getWorkorderHead',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })

  const list: any[] = await http({
    url: '/srmPurWorkorder/getWorkorderBody',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      workorderNos: info.records.map((i: any) => i.workorderNo)
    }
  })
  return {
    ...info,
    records: Object.freeze(
      info.records.map((item: any, index: number) => {
        return {
          ...item,
          list: getlist(list[index] && list[index].workorderRspList)
        }
      })
    )
  }
}
